import React from "react";
import styled from "styled-components";

const PermissionCheckbox = ({ isChecked, onChange }) => {
  return <Checkbox type="checkbox" checked={isChecked} onChange={onChange} />;
};

const Checkbox = styled.input`
  cursor: pointer;
  accent-color: #16a34a;
  width: 18px;
  height: 18px;
`;
export default PermissionCheckbox;
